export default () => ({
  root: {
    margin: 'auto',
    maxWidth: 1200,
  },
});
